<template>
  <div class="ts-menu-item" :class="{ 'has-icon': hasIcon }">
    <router-link :to="to" :class="{ exact }">
      <div class="icon">
        <slot name="icon"></slot>
      </div>
      <slot></slot>
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
.ts-menu-item {
  font-family: Roboto;
  font-size: 16px;
  color: #6d7587;

  .icon {
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
  }

  a {
    display: block;
    padding: 8px 0;
    margin: 4px 0;
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
    text-decoration: none;
    border: 1px solid transparent;

    &.router-link-exact-active.exact {
      background: #99ffd1;
      border: 1px solid rgba(235, 236, 240, 0.24);
      box-shadow: inset 0 4px 8px 0 rgba(24, 122, 92, 0.4), inset 0 -4px 8px 0 rgba(235, 255, 247, 0.88);
      border-radius: 28px;

      color: #33373d;
    }

    &.router-link-active.lenient {
      background: #99ffd1;
      border: 1px solid rgba(235, 236, 240, 0.24);
      box-shadow: inset 0 4px 8px 0 rgba(24, 122, 92, 0.4), inset 0 -4px 8px 0 rgba(235, 255, 247, 0.88);
      border-radius: 28px;

      color: #33373d;
    }
  }

  &.has-icon {
    a {
      padding-left: 8px;
    }
  }
}
</style>

<script>
export default {
  name: 'TsMenuItem',
  props: {
    to: {
      type: Object,
      default: () => ({ name: 'home' })
    }
  },
  data() {
    return {
      hasIcon: false
    };
  },
  computed: {
    exact() {
      return this.to.name === this.$route.name;
    }
  },
  mounted() {
    this.hasIcon = !!this.$slots.icon;
  }
};
</script>
